import Vue from 'vue'
import Router from 'vue-router'
import store from '@/plugins/store'

import Home from './views/Home.vue'
import Boletos from './views/Boletos.vue'
import Catalogos from './views/Catalogos.vue'
import ReportesTienda from './views/ReportesTienda.vue'
import ReportesTaquilla from './views/ReportesTaquilla.vue'
import Configuracion from './views/Configuracion.vue'
import EventoInfo from './views/EventoInfo.vue'
import ViewVentas from './views/Ventas.vue'
import ViewUsuarios from './views/Usuarios.vue'
import ViewComprarBoletos from './views/ComprarBoletos.vue'
import ViewComprarBoletosV2 from './views/ComprarBoletosV2.vue'
import BoletosEspeciales from './views/BoletosEspeciales.vue'
import VentaOficial from './views/VentaOficial.vue'
import Cortesias from './views/Cortesias.vue'
import Respaldos from './views/Respaldos.vue'
import Login from './components/Login.vue'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'VentaOficial',
      component: VentaOficial,
      meta: { requiresAuth: false }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: { requiresAuth: false }
    },
    {
      path: '/cortesias',
      name: 'Cortesias',
      component: Cortesias,
      meta: { requiresAuth: false }
    },
    {
      path: '/boletos',
      name: 'Boletos',
      component: Boletos,
      meta: { requiresAuth: true }
    },
    {
      path: '/respaldos',
      name: 'Respaldos',
      component: Respaldos,
      meta: { requiresAuth: true }
    },
    {
      path: '/boletos-especiales',
      name: 'BoletosEspeciales',
      component: BoletosEspeciales,
      meta: { requiresAuth: true }
    },
    {
      path: '/catalogos',
      name: 'Catalogos',
      component: Catalogos,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportes-taquilla',
      name: 'ReportesTaquilla',
      component: ReportesTaquilla,
      meta: { requiresAuth: true }
    },
    {
      path: '/reportes-tienda',
      name: 'ReportesTienda',
      component: ReportesTienda,
      meta: { requiresAuth: true }
    },
    {
      path: '/configuracion',
      name: 'Configuracion',
      component: Configuracion,
      meta: { requiresAuth: true }
    },
    {
      path: '/evento-info',
      name: 'EventoInfo',
      component: EventoInfo,
      meta: { requiresAuth: true }
    },
    {
      path: '/ventas',
      name: 'ViewVentas',
      component: ViewVentas,
      meta: { requiresAuth: true }
    },
    {
      path: '/usuarios',
      name: 'ViewUsuarios',
      component: ViewUsuarios,
      meta: { requiresAuth: true }
    },
    {
      path: '/comprar-boletos',
      name: 'ViewComprarBoletos',
      component: ViewComprarBoletos,
      meta: { requiresAuth: true }
    },
    {
      path: '/comprar-boletos-v2',
      name: 'ViewComprarBoletosV2',
      component: ViewComprarBoletosV2,
      meta: { requiresAuth: true }
    },
  ],
})

router.beforeEach ((to, from, next) => {
  // console.log('beforeEach :: ', to)
  // console.log('beforeEach :: ', to.meta.requiresAuth)
  // console.log('Store :: ', store.state.auth.token)
  if (to.meta.requiresAuth === undefined) {
    next({ path: '/' })
  } else if (!store.state.auth.token && (to.path !== '/login' && to.path !== '/' && to.path !== '/cortesias')) {
    next({ path: '/login' })
  }
  next()
})

export default router
